import React, {Component} from 'react';
import Aux from "react-aux";
import connect from "react-redux/es/connect/connect";
import * as actions from "../../store/actions";
import EnhancedTable from "../../components/EnhancedTable/EnhancedTable";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {TableFilter} from "../../components/TableFilter/TableFilter";

class Drugs extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            page: 0,
            pageSize: 10,
            data: [],
            sort: {sortKey: 'countryCode', direction: 'ASC'},
            sidebarOpen: false,
            filter: {
                countryCode: "",
                atcLetter: "",
                activeSubstance: "",
                manufacturer: "",
                brandName: "",
                genericName: ""
            }
        };
    }

    componentDidMount = async () => {
        await this.props.getCoveredCountries();
        await this.fetchData(0, 10, this.state.sort, this.state.filter);
    };

    fetchData = async (page, pageSize, sort, filter) => {
        await this.props.onDrugsFetch(page, pageSize, sort, filter);
    };

    handleATCSelect = (atcCode) => {
        let filter = {...this.state.filter};
        filter.atcLetter = atcCode;
        this.setState({filter});
    };

    handleCountrySelect = (countryCode) => {
        let filter = {...this.state.filter};
        filter.countryCode = countryCode;
        this.setState({filter});
    };

    setActiveSubstance = (activeSubstance) => {
        let filter = {...this.state.filter};
        filter.activeSubstance = activeSubstance;
        this.setState({filter});
    };

    setManufacturer = (manufacturer) => {
        let filter = {...this.state.filter};
        filter.manufacturer = manufacturer;
        this.setState({filter});
    };

    setBrandName = (brandName) => {
        let filter = {...this.state.filter};
        filter.brandName = brandName;
        this.setState({filter});
    };

    setGenericName = (genericName) => {
        let filter = {...this.state.filter};
        filter.genericName = genericName;
        this.setState({filter});
    };

    handleFilter = async () => {
        await this.fetchData(this.state.page, this.state.pageSize, this.state.sort, this.state.filter);
    };

    handleSort = async (prop, direction) => {
        let sort = {
            sortKey: prop,
            direction: direction.toUpperCase()
        };
        await this.setState({sort});
        await this.fetchData(this.state.page, this.state.pageSize, this.state.sort, this.state.filter);
    };

    handlePageChange = async (page) => {
        this.setState(() => {
            return {
                ...this.state,
                page: page
            };
        });
        await this.fetchData(this.state.page, this.state.pageSize, this.state.sort, this.state.filter);
    };

    handleRowChange = async (rows) => {
        await this.fetchData(this.state.page, rows, this.state.sort, this.state.filter);
        this.setState(() => {
            return {
                ...this.state,
                pageSize: rows,

            };
        });
    };

    renderTable = () => {
        if (this.props.loading) {
            return <div className={"d-flex align-items-center justify-content-center"}
                        style={{color: '#5c5a5d', minHeight: 60 + 'vh'}}><CircularProgress/></div>;
        }
        if (this.props.drugs && this.props.drugs.length === 0) {
            return <h2 style={{color: '#5c5a5d', minHeight: 60 + 'vh'}}>No drugs found!</h2>
        } else if (this.props.drugs) {
            return (
                <EnhancedTable history={this.props.history}
                               data={this.props.drugs}
                               rowCount={this.props.totalDrugs}
                               orderBy={this.state.sort.sortKey}
                               order={this.state.sort.direction.toLowerCase()}
                               rowsPerPage={this.state.pageSize}
                               page={this.state.page}
                               onSort={this.handleSort}
                               onPageChange={this.handlePageChange}
                               onPageSizeChange={this.handleRowChange}
                />
            )
        }

    };

    render() {
        return (
            <Aux>
                <TableFilter onATCSelect={this.handleATCSelect}
                             onCountrySelect={this.handleCountrySelect}
                             setActiveSubstance={this.setActiveSubstance}
                             setManufacturer={this.setManufacturer}
                             setBrandName={this.setBrandName}
                             setGenericName={this.setGenericName}
                             coveredCountries={this.props.coveredCountries}
                             applyFilter={this.handleFilter}
                />
                <div className={'mt-2'}>
                    {this.renderTable()}
                </div>
            </Aux>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onDrugsFetch: (page, pageSize, sort, filter) => dispatch(actions.getDrugs(page, pageSize, sort, filter)),
        getCoveredCountries: () => dispatch(actions.getCoveredCountries())
    }
};


const mapStateToProps = state => {
    return {
        coveredCountries: state.countries.coveredCountries,
        drugs: state.drugs.drugs,
        totalDrugs: state.drugs.totalDrugs,
        loading: state.drugs.loading
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Drugs);
